import { inject } from '@angular/core';
import { ActivityEntityName, EntityViewDisplay, FeatureFlags, QuotePro, QuoteTemplateSecurityRight, SecurityModuleTag, SurfaceType } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';
import { entityRecordUrl } from '@workbuddy/ui/v2/blocks/entity.record';
import { quoteTemplateStatusTag } from './presentation/quote.template.status.colour';

// Quote Templates on the quote document surface. Legacy edits a template in a dialog over its list
// and has no record URL, so every template link opens the generic preview page.
export const quoteTemplateManifest = registerManifest<QuotePro>({
  entity: ActivityEntityName.QuoteTemplate,
  slug: 'quote-templates',
  featureFlag: FeatureFlags.FinanceDocsQuoteTemplateV2,
  menu: {
    group: 'quotes',
    label: 'Quote Templates',
    icon: 'fa-calculator',
    order: 20,
    badge: SecurityModuleTag.Beta,
    authorize: () => inject(RightsService).hasRights(QuoteTemplateSecurityRight.CanAccess),
  },
  routes: {
    root: '/entity/quote-templates',
    record: id => entityRecordUrl('quote-templates', 'preview', id),
  },

  presentation: {
    tags: { status: quoteTemplateStatusTag },
  },

  board: {
    supportedDisplays: [EntityViewDisplay.Card],
    // Document-shaped, like a quote: the selection shows in the wide preview aside.
    panel: { kind: 'preview' },
    // One system view split by the Public / Draft pills: there is nothing to switch to, favourite or author.
    defaults: { header: { title: 'Quote Templates', showViewOptions: false } },
  },

  surfaces: {
    [SurfaceType.FinancialDocument]: () => import('./surface/quote.template.surface').then(m => m.quoteTemplateSurface),
  },

  // Read access mounts the document; Save, Publish / Unpublish and Delete check Manage on the surface.
  operations: {
    create: { surface: SurfaceType.FinancialDocument, authorize: ({ injector }) => injector.get(RightsService).hasRights(QuoteTemplateSecurityRight.Manage) },
    edit: { surface: SurfaceType.FinancialDocument, authorize: ({ injector }) => injector.get(RightsService).hasRights(QuoteTemplateSecurityRight.Manage) },
    preview: { surface: SurfaceType.FinancialDocument, authorize: ({ injector }) => injector.get(RightsService).hasRights(QuoteTemplateSecurityRight.CanAccess) },
  },
});
